document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[count-up]');

    elements.forEach(element => {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animateCountUp(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: 0.1 });

            observer.observe(element);
        }
    });

    function animateCountUp(target) {
        target.style.opacity = 1;
        const matches = target.textContent.trim().match(/\d+(?:[,. ]\d+)*/);
        if (!matches) {
            return;
        }
        target.innerHTML = target.textContent.replace(/\d+(?:[,. ]\d+)*/, `<span>${matches[0]}</span>`);
        const numberSpan = target.querySelector("span");
        const finalNumber = parseInt(matches[0].replace(/[,\. ]+/g, ""));
        const duration = parseFloat(target.getAttribute("count-up")) * 1000;
        animateNumber(numberSpan, finalNumber, duration);
    }

    function animateNumber(element, finalNumber, duration) {
        let startTimestamp = null;
        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            element.textContent = Math.floor(progress * finalNumber).toLocaleString();
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }
});
